import React from 'react';
import CladdingWork from "../images/services/CladdingWork/services.json"
import ColdInsulation from "../images/services/ColdInsulation/services.json"
import HotInsulation from "../images/services/HotInsulation/services.json"
import PackagingSolutionsInsulatedBoxes from "../images/services/PackagingSolutionsInsulatedBoxes/services.json"
import PackagingSolutionsMouldedBoxes from "../images/services/PackagingSolutionsMouldedBoxes/services.json"

export default function Services() {
    return (
        <div className="container mt-4">
            <div className="row">
                <p className='roboto fs-5'>
                    Starking Insulation delivers high-quality thermal solutions for packaging, industrial systems, and temperature-controlled transport.
                    Our range includes insulated, moulded, and PUFF boxes designed for maximum strength, durability, and temperature stability.
                    We specialize in hot and cold insulation for chemical plants, sugar factories, refineries, cold storage, and tanker applications.
                    Our expert cladding work ensures long-lasting protection, improved efficiency, and superior system performance.
                    With advanced technology and reliable workmanship, we provide complete insulation solutions for every industry need.
                </p>
            </div>
            <div className="row">
                <h3 className='product-title'><span className='roboto-title'>Cladding Work</span></h3>
                <p class="fs-5">We are a leading Service provider of Cladding Work from Pune, India. High-quality aluminium and stainless steel cladding for insulation systems.
                    Protects insulation from weather, corrosion, and mechanical damage.
                    Improves durability and overall system performance.
                    Suitable for industrial plants, pipelines, and storage tanks.
                    Provides a clean, professional, and long-lasting finish.</p>
                {CladdingWork.map((item) => (
                    <div className="col-12 col-md-6 col-lg-3 p-3" key={item.id}>
                        <div className="card h-100">
                            <div className='imagediv'>
                            <img className="card-img-top" src={require(`../images/services/CladdingWork/${item.image}`)} alt="Card image" />
                            </div>
                            <div className="card-body">
                                <h4 className="card-title">{item.name}</h4>
                                {/* <p className="card-text">{item.details}</p> */}
                                {/* <a href="#" className="btn btn-primary">{item.profile}</a> */}
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <div className="row">
                <h3 className='product-title'><span className='roboto-title'>Cold Insulation</span></h3>
                <p class="fs-5">We are a leading Service provider of Cold Insulation from Pune, India. Specialised cold insulation for controlled temperature environments.
                    Prevents condensation, moisture damage, and temperature gain.
                    Ideal for pharma, cold storage units, tankers, and food processing.
                    Ensures safe transport of chilled and frozen products.
                    Delivers consistent thermal performance in low-temperature systems.</p>
                {ColdInsulation.map((item) => (
                    <div className="col-12 col-md-6 col-lg-3 p-3" key={item.id}>
                        <div className="card h-100">
                            <div className='imagediv'>
                            <img className="card-img-top" src={require(`../images/services/ColdInsulation/${item.image}`)} alt="Card image" />
                            </div>
                            <div className="card-body">
                                <h4 className="card-title">{item.name}</h4>
                                {/* <p className="card-text">{item.details}</p> */}
                                {/* <a href="#" className="btn btn-primary">{item.profile}</a> */}
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <div className="row">
                <h3 className='product-title'><span className='roboto-title'>Hot Insulation</span></h3>
                <p class="fs-5">We are a leading Service provider of Cold Insulation from Pune, India. Expert hot insulation for high-temperature pipelines and equipment.
                    Reduces heat loss and improves energy efficiency.
                    Used in chemical plants, sugar factories, boilers, and refineries.
                    Protects workers from burns and enhances operational safety.
                    Designed for long-term performance under extreme conditions.</p>
                {HotInsulation.map((item) => (
                    <div className="col-12 col-md-6 col-lg-3 p-3" key={item.id}>
                        <div className="card h-100">
                            <div className='imagediv'>
                            <img className="card-img-top" src={require(`../images/services/HotInsulation/${item.image}`)} alt="Card image" />
                            </div>
                            <div className="card-body">
                                <h4 className="card-title">{item.name}</h4>
                                {/* <p className="card-text">{item.details}</p> */}
                                {/* <a href="#" className="btn btn-primary">{item.profile}</a> */}
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <div className="row">
                <h3 className='product-title'><span className='roboto-title'>Packaging Solutions Insulated Boxes</span></h3>
                <p class="fs-5">We are a leading Service provider of Packaging Solutions Insulated Boxes from Pune, India. Our insulated boxes maintain stable temperatures for sensitive products.
                    Designed for pharmaceuticals, food, and industrial transport.
                    Lightweight, durable, and high thermal efficiency.
                    Prevents heat gain or loss in any environment.
                    Ideal for long-distance shipping and safe handling.</p>
                {PackagingSolutionsInsulatedBoxes.map((item) => (
                    <div className="col-12 col-md-6 col-lg-3 p-3" key={item.id}>
                        <div className="card h-100">
                            <div className='imagediv'>
                            <img className="card-img-top" src={require(`../images/services/PackagingSolutionsInsulatedBoxes/${item.image}`)} alt="Card image" />
                            </div>
                            <div className="card-body">
                                <h4 className="card-title">{item.name}</h4>
                                {/* <p className="card-text">{item.details}</p> */}
                                {/* <a href="#" className="btn btn-primary">{item.profile}</a> */}
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <div className="row">
                <h3 className='product-title'><span className='roboto-title'>Packaging Solutions Moulded Boxes for Pharmaceutical Sector</span></h3>
                <p class="fs-5">We are a leading manufacturer of Packaging Solutions Moulded Boxes for Pharmaceutical Sector from Pune, India. 
                    We have launched this as the first product in India for Pharmaceutical Sector with customised size and design.
                    Premium moulded boxes engineered with precision and strength.
                    Custom-designed shapes for perfect product fit and protection.
                    Exceptional durability with superior insulation performance.
                    Lightweight yet impact-resistant, ideal for industrial logistics.
                    Our most advanced and in-demand packaging solution.</p>
                {PackagingSolutionsMouldedBoxes.map((item) => (
                    <div className="col-12 col-md-6 col-lg-3 p-3" key={item.id}>
                        <div className="card h-100">
                            <div className='imagediv'>
                            <img className="card-img-top" src={require(`../images/services/PackagingSolutionsMouldedBoxes/${item.image}`)} alt="Card image" />
                            </div>
                            <div className="card-body">
                                <h4 className="card-title">{item.name}</h4>
                                {/* <p className="card-text">{item.details}</p> */}
                                {/* <a href="#" className="btn btn-primary">{item.profile}</a> */}
                            </div>
                        </div>
                    </div>
                ))}
            </div>

        </div>
    );
}
